import {
  useMediaStreamSetToPointsMutation,
  StreamPureSetToCompanyPointsMutationInput,
} from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import { StreamSetToPointsResultType, UseStreamSetToPointsType } from '../types';

const useStreamSetToPoints = (): UseStreamSetToPointsType => {
  const [setMutation, setMutationResult] = useMediaStreamSetToPointsMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (input: StreamPureSetToCompanyPointsMutationInput) => {
    const result = await setMutation({
      variables: {
        input,
      },
    });

    return !!result.data?.result?.ok;
  };

  const result: StreamSetToPointsResultType = {
    error: setMutationResult.error,
    loading: setMutationResult.loading,
    called: setMutationResult.called,
  };

  return [request, result];
};

export default useStreamSetToPoints;
